import React from 'react'
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Skills from './components/Skills/Skills';
import Footer from './components/Footer/Footer';
import Header  from "./components/Header/Header";
import Navbar from './components/Navbar/Navbar';
import Portfolio from './components/Projects/Projects';
import Publications from './components/Publications/Publications';
import Experience from './components/Experience/Experience';

const App = () => {
  return (
    <div>
        <Header/>
        <Navbar/>
        <About/>
        <Experience/>
        <Skills/>
        <Portfolio/>
        <Publications/>
        <Contact/>
        <Footer/>

    </div>
  )
}

export default App